import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';
import { HttpGuardService } from 'src/app/guards/http-guard.service';
import * as moment from "moment-timezone";
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeviceServiceService {

  constructor(private httpGuard: HttpGuardService, private datePipe: DatePipe) { }

  getDevices(devicePayload: any) {
    const payload = {
      siteId: devicePayload.siteId,
      deviceType: devicePayload.deviceType,
      deviceName: devicePayload.deviceName
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.devices}/${devicePayload.page}`, payload);
  }

  deviceSiteAllocation(deviceSiteAllocationPayload: any) {
    const payload = {
      siteId: deviceSiteAllocationPayload.siteId,
      deviceId: deviceSiteAllocationPayload.deviceId,
      deviceType: deviceSiteAllocationPayload.deviceType,
      currentTime: deviceSiteAllocationPayload.currentTime
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.deviceSiteAllocation, payload);
  }

  deviceSiteDeallocation(deviceSiteDeallocationPayload: any) {
    const payload = {
      siteId: deviceSiteDeallocationPayload.siteId,
      deviceId: deviceSiteDeallocationPayload.deviceId,
      deviceType: deviceSiteDeallocationPayload.deviceType,
      currentTime: deviceSiteDeallocationPayload.currentTime
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.deviceSiteDeallocation, payload);
  }

  availableEntities(availableEntitiesPayload: any) {
    const payload = {
      siteId: availableEntitiesPayload.siteId,
      static: true
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.availableEntities, payload);
  }


  deviceTypes() {
    const payload = {
      static: true
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.deviceTypes, payload);
  }

  deviceRawData(payloadData: any) {
    // const now = moment(new Date(), 'yyyy-MM-ddTHH:mm:ssZZ');
    // const lastHour = now.clone().startOf('minute').clone().subtract(60, 'minute').startOf('minute');
    const payload = {
      from: payloadData?.from,
      to: payloadData?.to,
      cid: payloadData?.cid ? payloadData?.cid : undefined,
      did: payloadData?.did ? payloadData?.did : undefined,
      rawData: payloadData?.rawData ? payloadData?.rawData : undefined
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.deviceRawData, payload, payloadData?.loader);
  }
  
}
